





































































































































































































































































































import Component from "vue-class-component";
import Vue from "vue";
import {
  PolicyFundDto,
  PolicyBenefitDto,
  PolicyValuesDto,
  PolicyDto,
  PerformanceChartSeriesDto,
  PerformanceChartDataDto
} from "@/api/ClientPortalApiClient";
import ApiFactory from "@/api/ApiFactory";
import AlertService from "@/services/alert.service";
import { SEE_OTHER } from "http-status-codes";
import { LoadingSpinnerService, RoleStore } from "@/store";
import { Dictionary } from "vuex";
import FundPerformanceChart from "@/views/policies/charts/FundPerformanceChart.vue";
import FundValuePerformanceChart from "@/views/policies/charts/FundValuePerformanceChart.vue";
import FundMixChart from "@/views/policies/charts/FundMixChart.vue";
import PolicyValues from "@/views/policies/components/PolicyValues.vue";
import PolicyFunds from "@/views/policies/components/PolicyFunds.vue";
import BackButton from "@/components/BackButton.vue";
import { FormatDate } from "@/filters/FormatDate";

@Component({
  components: {
    FundPerformanceChart,
    FundValuePerformanceChart,
    FundMixChart,
    PolicyValues,
    PolicyFunds,
    BackButton
  }
})
export default class PolicyDetails_Pension extends Vue {
  private policyDetails: PolicyDto = new PolicyDto();
  private policyId: number | undefined;
  private contactId: number | undefined;

  async created() {
    LoadingSpinnerService.Show("Loading policy details...");
    try {
      this.contactId = parseInt(this.$route.params.contactId);
      this.policyId = parseInt(this.$route.params.policyId);
      await this.getPolicyDetails();
      LoadingSpinnerService.Hide();
    } catch (e) {
      LoadingSpinnerService.Failure(
        "Failed to load policy details. Please try again."
      );
    }
  }

  private async getPolicyDetails() {
    if (!this.policyId || !this.contactId)
      throw new Error("Request is not valid");
    const api = ApiFactory.CreateDataClient();
    const result = await api.policies_GetByPolicyId(
      this.contactId,
      this.policyId
    );
    this.policyDetails = result || new PolicyDto();
  }

  get policyEndDateString(): string {
    return new Date(this.policyDetails.maturityDate) <= new Date("01/01/1900")
      ? "Open Ended"
      : FormatDate.format(this.policyDetails.maturityDate);
  }

  get IsExternalBroker(): boolean {
    return RoleStore.isExternalBroker;
  }
}
